













import { Component, Prop, mixins } from 'nuxt-property-decorator'
import { defineComponent, ref, useContext } from '@nuxtjs/composition-api'
import { Logger } from '../composition/Logger'
import { SectionCore } from '@/mixins/sectionCore'
import { news } from '@/apollo/queries/news'
import Loader from '@/plugins/loader/Load.vue'
import type { QueryElementsArgs } from '@/apollo/composition-functions'
import SectionBasic from '@/components/SectionBasic.vue'
import { newsAdapter } from '@/apollo/adapters/modules'
import CardDefaultList from '@/components/CardLists/CardDefaultList.vue'

@Component
class SectionCardNews extends mixins(SectionCore) {
  @Prop() readonly news: ReadonlyArray<any> = []
  @Prop() readonly loadLastNews: boolean = false
}

export default defineComponent({
  name: 'SectionCardNews',
  components: {
    SectionBasic,
    CardDefaultList,
    Loader,
  },
  props: SectionCardNews.options.props,
  setup(props) {
    const loadNews = ref(false)
    const queryNewsAdapted = ref([])
    const ctx = useContext()
    const filters: QueryElementsArgs = {
      orderBy: { activeFrom: 'desc' },
      first: 3,
    }

    const getLastNews = async () => {
      loadNews.value = true
      try {
        const {
          data: { news: loadedNews },
        } = await ctx.$api.requests.sendGraphqlQuery({
          query: news.loc?.source.body,
          variables: filters,
        })
        queryNewsAdapted.value = newsAdapter(loadedNews)
        loadNews.value = false
      } catch (e) {
        Logger.error(e)
        loadNews.value = false
      }
    }

    if (props.loadLastNews) {
      getLastNews()
    }

    return {
      queryNewsAdapted,
      loadNews,
    }
  },
})
